import _defineProperty from "/vercel/path1/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
var __jsx = React.createElement;
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import React, { useContext, useState } from "react";
import AwesomeIcon from "../AwesomeIcon";
import { faCircleCheck, faDiamondExclamation, faPhonePlus } from "@fortawesome/pro-regular-svg-icons";
import classNames from "classnames";
import { useTranslation } from "react-i18next";
import { GatewayContext } from "./GatewayContext";
import { format } from "date-fns";
import constants from "../../utils/constants";
import { startCase, truncate } from "lodash";
import POC from "./POC";
import POCModal from "./POCModal";
import { useGetPOCNumber } from "./services";
function GatewayIndicator(_ref) {
  var isVisible = _ref.isVisible;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var _useContext = useContext(GatewayContext),
    gatewayData = _useContext.gatewayData,
    offlineGatewayCount = _useContext.offlineGatewayCount,
    totalGateway = _useContext.totalGateway,
    formatTimeDifference = _useContext.formatTimeDifference,
    isLoading = _useContext.isLoading;
  var _useState = useState(""),
    activeID = _useState[0],
    setActiveID = _useState[1];
  var _useState2 = useState(false),
    isPOCModalVisible = _useState2[0],
    setIsPOCModalVisible = _useState2[1];
  var _useState3 = useState({}),
    selectedGateway = _useState3[0],
    setselectedGateway = _useState3[1];
  var _useGetPOCNumber = useGetPOCNumber(isVisible),
    qure_poc = _useGetPOCNumber.data,
    refetchQurePOC = _useGetPOCNumber.refetch;
  return /*#__PURE__*/React.createElement(React.Fragment, null, isLoading ? /*#__PURE__*/React.createElement("div", {
    className: "flex items-center justify-center bold text-gray-900 dark:text-white bg-gray-100 dark:bg-gray-900 w-full h-full"
  }, "Loading...") : /*#__PURE__*/React.createElement("div", {
    className: "text-gray-800 text-left dark:text-gray-100"
  }, !offlineGatewayCount ? /*#__PURE__*/React.createElement("div", {
    className: "bg-green-300 dark:bg-green-800 flex space-x-4 px-5 py-4 items-center"
  }, /*#__PURE__*/React.createElement(AwesomeIcon, {
    name: faCircleCheck,
    className: "text-green-700 dark:text-green-400"
  }), /*#__PURE__*/React.createElement("p", {
    className: "font-medium text-md"
  }, t("gateways_are_online", {
    totalGateway: totalGateway
  }))) : /*#__PURE__*/React.createElement("div", {
    className: "dark:bg-yellow-800 bg-yellow-300 flex space-x-4 px-5 py-4 items-center"
  }, /*#__PURE__*/React.createElement(AwesomeIcon, {
    name: faDiamondExclamation,
    className: "text-yellow-700 dark:text-yellow-500"
  }), /*#__PURE__*/React.createElement("p", {
    className: "font-medium text-md"
  }, t("gateways_are_offline", {
    offlineGatewayCount: offlineGatewayCount,
    totalGateway: totalGateway
  }))), /*#__PURE__*/React.createElement("div", {
    className: "p-5 space-y-5 overflow-y-auto scrollbar-light dark:scrollbar"
  }, gatewayData === null || gatewayData === void 0 ? void 0 : gatewayData.map(function (obj, id) {
    var _obj$gateway, _obj$gateway2, _obj$gateway3;
    return /*#__PURE__*/React.createElement("div", {
      key: id
    }, /*#__PURE__*/React.createElement("p", {
      className: "text-gray-800 dark:text-gray-100 font-medium"
    }, startCase("".concat(obj === null || obj === void 0 ? void 0 : obj.workspace_name)), " ", /*#__PURE__*/React.createElement("span", null, "(", (obj === null || obj === void 0 || (_obj$gateway = obj.gateway) === null || _obj$gateway === void 0 ? void 0 : _obj$gateway.length) - (obj === null || obj === void 0 ? void 0 : obj.offline_gateway_count), " of", " ", obj === null || obj === void 0 || (_obj$gateway2 = obj.gateway) === null || _obj$gateway2 === void 0 ? void 0 : _obj$gateway2.length, " online)")), /*#__PURE__*/React.createElement("div", {
      className: "space-y-5"
    }, obj === null || obj === void 0 || (_obj$gateway3 = obj.gateway) === null || _obj$gateway3 === void 0 ? void 0 : _obj$gateway3.map(function (item, index) {
      return /*#__PURE__*/React.createElement("div", {
        key: index,
        className: classNames("border grid grid-cols-12 rounded-lg overflow-hidden border-gray-500/50 space-y-2 my-3", {
          "border-yellow-500 dark:border-yellow-700": (item === null || item === void 0 ? void 0 : item.time_difference) > constants.GATEWAY_TIME.TIME_DIFFERENCE
        })
      }, /*#__PURE__*/React.createElement("div", {
        className: classNames("col-span-10 sm:col-span-12 space-y-4 p-4 group")
      }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("p", {
        title: item === null || item === void 0 ? void 0 : item.gateway_name,
        className: "text-gray-800 dark:text-gray-200"
      }, "Gateway ", 1 + +index, " |", " ", truncate(item === null || item === void 0 ? void 0 : item.gateway_name, {
        length: 25
      })), (item === null || item === void 0 ? void 0 : item.time_difference) < constants.GATEWAY_TIME.TIME_DIFFERENCE ? /*#__PURE__*/React.createElement("p", {
        className: "text-green-500 text-md"
      }, t("online_key"), " ", /*#__PURE__*/React.createElement("span", {
        className: "text-gray-800 dark:text-gray-200"
      }, t("since_key"), " ", format(new Date(item === null || item === void 0 ? void 0 : item.last_online), "h:mm a, d MMM"), " ")) : /*#__PURE__*/React.createElement("p", {
        className: "text-yellow-600 dark:text-yellow-500 text-md"
      }, t("offline_for"), " ", formatTimeDifference(item === null || item === void 0 ? void 0 : item.time_difference), " ", /*#__PURE__*/React.createElement("span", {
        className: "text-gray-800 dark:text-gray-200"
      }, t("since_key"), " ", format(new Date(item === null || item === void 0 ? void 0 : item.last_online), "h:mm a, d MMM"), " "))), /*#__PURE__*/React.createElement(POC, {
        gatewayDetails: item,
        activeID: activeID,
        setActiveID: setActiveID,
        qure_poc: qure_poc,
        refetchQurePOC: refetchQurePOC,
        isFirstGateway: id === 0 && index === 0
      })), /*#__PURE__*/React.createElement("div", {
        className: "col-span-2 sm:hidden flex justify-end p-4",
        onClick: function onClick() {
          setIsPOCModalVisible(true);
          setselectedGateway(_objectSpread(_objectSpread({}, item), {}, {
            isFirstGateway: id === 0 && index === 0,
            qure_poc: qure_poc,
            refetchQurePOC: refetchQurePOC
          }));
        }
      }, /*#__PURE__*/React.createElement(AwesomeIcon, {
        name: faPhonePlus,
        size: "sm"
      })));
    })));
  }))), /*#__PURE__*/React.createElement(POCModal, {
    isPOCModalVisible: isPOCModalVisible,
    setIsPOCModalVisible: setIsPOCModalVisible,
    selectedGateway: selectedGateway
  }));
}
export default GatewayIndicator;